import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { DeviceMasterProvider } from '../../data/DataProviders/DeviceMasterProvider';
import { SiteProfileDataProvider } from '../../data/DataProviders/SiteProfileDataProvider';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { AppRoutes } from '../../routes';
import { AddDeviceProfile } from '../device-management/AddDeviceProfile';
import { DeviceManagement } from '../device-management/DeviceManagement';
import { SiteProfileContainer } from './SiteProfileContainer';

export const SiteManagement: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();
    return (
        <>
            {'siteId' in currentAppRoute && (
                <Switch>
                    <Route
                        path={[
                            AppRoutes.StarfishDeviceProfile,
                            AppRoutes.DeviceProfile,
                            AppRoutes.PxDeviceProfile,
                            AppRoutes.MeshDeviceProfile,
                            AppRoutes.AcquireSubscription,
                            AppRoutes.EditConnectedDevice,
                            AppRoutes.EditDeviceProfile,
                            AppRoutes.ChildDeviceProfile,
                            AppRoutes.EditDeviceProfile,
                        ]}
                    >
                        <DeviceManagement />
                    </Route>
                    <DataProviderCache for={'site-profile'}>
                        <SiteProfileDataProvider siteId={currentAppRoute.siteId}>
                            <Route path={AppRoutes.SiteProfile}>
                                <SiteProfileContainer />
                            </Route>
                            <Route exact path={AppRoutes.AddDevice}>
                                <DeviceMasterProvider>
                                    <AddDeviceProfile />
                                </DeviceMasterProvider>
                            </Route>
                        </SiteProfileDataProvider>
                    </DataProviderCache>
                </Switch>
            )}
        </>
    );
};
